import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '../material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { HttpClientModule } from "@angular/common/http";

import { SuppliersRoutingModule } from './suppliers-routing.module';
import { SuppliersComponent } from './suppliers.component';
import { MaintainSupplierComponent } from './maintain-supplier/maintain-supplier.component';
import { ListSupplierComponent } from './list-supplier/list-supplier.component';

@NgModule({
  imports: [
    CommonModule,
    SuppliersRoutingModule,
    MaterialModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRippleModule,
    MatDialogModule,
    //DatePipe,
    NgxSpinnerModule,
    GridModule,
    DropDownsModule,
    ButtonsModule,
    DateInputsModule,
    LayoutModule,
    PDFExportModule,
    ExcelExportModule,
    DialogsModule,
    UploadsModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  declarations: [SuppliersComponent,
    MaintainSupplierComponent,
    ListSupplierComponent,
  ]
})
export class SuppliersModule { }
